import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
var SIconLegacy_SIconLegacyType = /*#__PURE__*/ function(SIconLegacyType) {
    SIconLegacyType["ChevronDown"] = "chevron-down";
    SIconLegacyType["ChevronRight"] = "chevron-right";
    SIconLegacyType["ChevronRightLight"] = "chevron-right-light";
    SIconLegacyType["ChevronDownSkinny"] = "chevron-down-skinny";
    SIconLegacyType["Paywall"] = "paywall";
    SIconLegacyType["PaywallOpen"] = "paywall-open";
    SIconLegacyType["NoMatch"] = "no-match";
    SIconLegacyType["Search"] = "search";
    SIconLegacyType["LogoFull"] = "logo-full";
    SIconLegacyType["LogoColor"] = "logo-color";
    SIconLegacyType["Logo"] = "logo";
    SIconLegacyType["NodeImage"] = "node-image";
    SIconLegacyType["NodeDiv"] = "node-div";
    SIconLegacyType["NodeText"] = "node-text";
    SIconLegacyType["NodeVideo"] = "node-video";
    SIconLegacyType["Plus"] = "plus";
    SIconLegacyType["NodeZStack"] = "node-z-stack";
    SIconLegacyType["NodeStack"] = "node-stack";
    SIconLegacyType["NodeNavigation"] = "node-navigation";
    SIconLegacyType["PropertiesLinked"] = "properties-linked";
    SIconLegacyType["PropertiesUnlinked"] = "properties-unlinked";
    SIconLegacyType["Italic"] = "italic";
    SIconLegacyType["ItalicNot"] = "italic-not";
    SIconLegacyType["Youtube"] = "youtube";
    SIconLegacyType["ShadowInside"] = "shadow-inside";
    SIconLegacyType["ShadowOutside"] = "shadow-outside";
    SIconLegacyType["PaywalledUser"] = "paywalled-user";
    SIconLegacyType["PaywallRate"] = "paywall-rate";
    SIconLegacyType["PaywallConversion"] = "paywall-conversion";
    SIconLegacyType["Proceeds"] = "proceeds";
    SIconLegacyType["PlusThick"] = "plus-thick";
    SIconLegacyType["Globe"] = "globe";
    SIconLegacyType["NodeDrawer"] = "node-drawer";
    SIconLegacyType["MoreVertical"] = "more-vertical";
    SIconLegacyType["Link"] = "link";
    SIconLegacyType["LinkOff"] = "link-off";
    SIconLegacyType["Gift"] = "gift";
    SIconLegacyType["GooglePlay"] = "google-play";
    SIconLegacyType["NodeAnimation"] = "node-animation";
    SIconLegacyType["CornersAll"] = "corners-all";
    return SIconLegacyType;
}({});
const SIconLegacy = ({ width: w, height: h, size: s = 24, color = "currentColor", type, className })=>{
    const size = "number" == typeof s ? s : "sm" === s ? 16 : "md" === s ? 24 : 36;
    const width = `${w || size}`;
    const height = `${h || size}`;
    switch(type){
        case "chevron-down":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8,12a1,1,0,0,1-.707-.293l-6-6A1,1,0,0,1,2.707,4.293L8,9.586l5.293-5.293a1,1,0,1,1,1.414,1.414l-6,6A1,1,0,0,1,8,12Z",
                        fill: color
                    })
                })
            });
        case "chevron-right":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                    })
                })
            });
        case "chevron-right-light":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                        fill: "none",
                        stroke: color,
                        strokeMiterlimit: "10",
                        points: "7,2 17,12 7,22 ",
                        transform: "translate(0, 0)"
                    })
                })
            });
        case "chevron-down-skinny":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M9,23a1,1,0,0,1-.818-1.573L14.779,12l-6.6-9.427A1,1,0,0,1,9.819,1.427l7,10a1,1,0,0,1,0,1.146l-7,10A1,1,0,0,1,9,23Z",
                        fill: color
                    })
                })
            });
        case "paywall":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M18,0H6C4.346,0,3,1.346,3,3v18c0,1.654,1.346,3,3,3h12c1.654,0,3-1.346,3-3V3C21,1.346,19.654,0,18,0z M19,20c0,0.552-0.448,1-1,1H6c-0.552,0-1-0.448-1-1V4c0-0.552,0.448-1,1-1h12c0.552,0,1,0.448,1,1V20z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            "data-color": "color-2",
                            x: "7",
                            y: "15",
                            width: "10",
                            height: "4"
                        })
                    ]
                })
            });
        case "paywall-open":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    fill: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    })
                })
            });
        case "no-match":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M23.444,10.239a22.936,22.936,0,0,0-2.492-2.948l-4.021,4.021A5.026,5.026,0,0,1,17,12a5,5,0,0,1-5,5,5.026,5.026,0,0,1-.688-.069L8.055,20.188A10.286,10.286,0,0,0,12,21c5.708,0,9.905-5.062,11.445-7.24A3.058,3.058,0,0,0,23.444,10.239Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M12,3C6.292,3,2.1,8.062.555,10.24a3.058,3.058,0,0,0,0,3.52h0a21.272,21.272,0,0,0,4.784,4.9l3.124-3.124a5,5,0,0,1,7.071-7.072L8.464,15.536l10.2-10.2A11.484,11.484,0,0,0,12,3Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M1,24a1,1,0,0,1-.707-1.707l22-22a1,1,0,0,1,1.414,1.414l-22,22A1,1,0,0,1,1,24Z"
                        })
                    ]
                })
            });
        case "search":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: color,
                            d: "M7,14c-3.86,0-7-3.14-7-7s3.14-7,7-7s7,3.14,7,7S10.86,14,7,14z M7,2C4.243,2,2,4.243,2,7s2.243,5,5,5 s5-2.243,5-5S9.757,2,7,2z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            "data-color": "color-2",
                            d: "M15.707,14.293L13.314,11.9c-0.411,0.529-0.885,1.003-1.414,1.414l2.393,2.393 C14.488,15.902,14.744,16,15,16s0.512-0.098,0.707-0.293C16.098,15.316,16.098,14.684,15.707,14.293z"
                        }),
                        " "
                    ]
                })
            });
        case "logo-full":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 157 22",
                version: "1.1",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    id: "Design-Guidelines",
                    stroke: "none",
                    strokeWidth: "1",
                    fill: "none",
                    fillRule: "evenodd",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                        id: "Superwall-Design/Guidelines-Copy",
                        transform: "translate(-139.000000, -71.000000)",
                        fillRule: "nonzero",
                        strokeWidth: "0.5",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                            id: "Group",
                            transform: "translate(139.579010, 71.340393)",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M7.268,20.7 C7.43666667,20.7 7.57083333,20.6501667 7.6705,20.5505 C7.77016667,20.4508333 7.82,20.3166667 7.82,20.148 L7.82,20.148 L7.82,18.538 C9.44533333,18.3693333 10.7371667,17.871 11.6955,17.043 C12.6538333,16.215 13.133,15.134 13.133,13.8 C13.133,12.8953333 12.9413333,12.1516667 12.558,11.569 C12.1746667,10.9863333 11.5805,10.5033333 10.7755,10.12 C9.9705,9.73666667 8.88566667,9.39166667 7.521,9.085 C6.53966667,8.83966667 5.7845,8.60966667 5.2555,8.395 C4.7265,8.18033333 4.34316667,7.935 4.1055,7.659 C3.86783333,7.383 3.749,7.038 3.749,6.624 C3.749,6.01066667 3.9905,5.543 4.4735,5.221 C4.9565,4.899 5.61966667,4.738 6.463,4.738 C7.22966667,4.738 7.86983333,4.90283333 8.3835,5.2325 C8.89716667,5.56216667 9.2,5.97233333 9.292,6.463 C9.41466667,6.739 9.637,6.877 9.959,6.877 L9.959,6.877 L12.144,6.877 C12.282,6.877 12.397,6.831 12.489,6.739 C12.581,6.647 12.627,6.532 12.627,6.394 C12.5963333,5.82666667 12.3931667,5.244 12.0175,4.646 C11.6418333,4.048 11.0975,3.52283333 10.3845,3.0705 C9.6715,2.61816667 8.81666667,2.323 7.82,2.185 L7.82,2.185 L7.82,0.552 C7.82,0.383333333 7.77016667,0.249166667 7.6705,0.1495 C7.57083333,0.0498333333 7.43666667,-3.55271368e-14 7.268,-3.55271368e-14 L7.268,-3.55271368e-14 L5.842,-3.55271368e-14 C5.68866667,-3.55271368e-14 5.55833333,0.0498333333 5.451,0.1495 C5.34366667,0.249166667 5.29,0.383333333 5.29,0.552 L5.29,0.552 L5.29,2.139 C3.78733333,2.323 2.60283333,2.829 1.7365,3.657 C0.870166667,4.485 0.437,5.497 0.437,6.693 C0.437,8.01166667 0.858666667,9.02366667 1.702,9.729 C2.54533333,10.4343333 3.87166667,11.0016667 5.681,11.431 C6.76966667,11.7223333 7.59383333,11.9715 8.1535,12.1785 C8.71316667,12.3855 9.131,12.627 9.407,12.903 C9.683,13.179 9.821,13.524 9.821,13.938 C9.821,14.5666667 9.54883333,15.0611667 9.0045,15.4215 C8.46016667,15.7818333 7.659,15.962 6.601,15.962 C5.65033333,15.962 4.90283333,15.7856667 4.3585,15.433 C3.81416667,15.0803333 3.45766667,14.6433333 3.289,14.122 C3.197,13.9686667 3.10116667,13.8575 3.0015,13.7885 C2.90183333,13.7195 2.76,13.685 2.576,13.685 L2.576,13.685 L0.506,13.685 C0.368,13.685 0.249166667,13.7348333 0.1495,13.8345 C0.0498333333,13.9341667 -1.42108547e-14,14.0453333 -1.42108547e-14,14.168 C0.0306666667,14.8733333 0.249166667,15.5365 0.6555,16.1575 C1.06183333,16.7785 1.65983333,17.3036667 2.4495,17.733 C3.23916667,18.1623333 4.186,18.4306667 5.29,18.538 L5.29,18.538 L5.29,20.148 C5.29,20.3166667 5.34366667,20.4508333 5.451,20.5505 C5.55833333,20.6501667 5.68866667,20.7 5.842,20.7 L5.842,20.7 L7.268,20.7 Z",
                                    id: "Path",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M24.718,18.63 C26.788,18.63 28.3941667,18.101 29.5365,17.043 C30.6788333,15.985 31.25,14.3826667 31.25,12.236 L31.25,12.236 L31.25,2.875 C31.25,2.70633333 31.2001667,2.56833333 31.1005,2.461 C31.0008333,2.35366667 30.8666667,2.3 30.698,2.3 L30.698,2.3 L28.582,2.3 C28.4133333,2.3 28.2753333,2.35366667 28.168,2.461 C28.0606667,2.56833333 28.007,2.70633333 28.007,2.875 L28.007,2.875 L28.007,12.236 C28.007,13.4473333 27.7195,14.3596667 27.1445,14.973 C26.5695,15.5863333 25.753,15.893 24.695,15.893 C23.637,15.893 22.8205,15.5863333 22.2455,14.973 C21.6705,14.3596667 21.383,13.4473333 21.383,12.236 L21.383,12.236 L21.383,2.875 C21.383,2.70633333 21.3293333,2.56833333 21.222,2.461 C21.1146667,2.35366667 20.9766667,2.3 20.808,2.3 L20.808,2.3 L18.692,2.3 C18.5233333,2.3 18.3891667,2.35366667 18.2895,2.461 C18.1898333,2.56833333 18.14,2.70633333 18.14,2.875 L18.14,2.875 L18.14,12.236 C18.14,14.3826667 18.715,15.985 19.865,17.043 C21.015,18.101 22.6326667,18.63 24.718,18.63 Z",
                                    id: "Path",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M43.916,2.3 L44.2592031,2.30512109 C45.9518594,2.35633203 47.294125,2.791625 48.286,3.611 C49.344,4.485 49.873,5.75766667 49.873,7.429 C49.873,9.085 49.344,10.3385 48.286,11.1895 C47.228,12.0405 45.7713333,12.466 43.916,12.466 L43.916,12.466 L40.535,12.466 L40.535,17.848 L40.52856,17.94506 C40.5113867,18.0689533 40.4598667,18.1707667 40.374,18.2505 C40.2666667,18.3501667 40.1286667,18.4 39.96,18.4 L39.96,18.4 L37.752,18.4 L37.66276,18.39356 C37.5474533,18.3763867 37.4468667,18.3248667 37.361,18.239 C37.2536667,18.1316667 37.2,18.0013333 37.2,17.848 L37.2,17.848 L37.2,2.875 L37.20598,2.77748 C37.2219267,2.65236 37.2697667,2.54686667 37.3495,2.461 C37.4491667,2.35366667 37.5833333,2.3 37.752,2.3 L37.752,2.3 L43.916,2.3 Z M43.801,4.876 L40.489,4.876 L40.489,9.89 L43.801,9.89 C44.6903333,9.89 45.3688333,9.67916667 45.8365,9.2575 C46.3041667,8.83583333 46.538,8.21866667 46.538,7.406 C46.538,6.60866667 46.3118333,5.98766667 45.8595,5.543 C45.4071667,5.09833333 44.721,4.876 43.801,4.876 L43.801,4.876 Z",
                                    id: "Combined-Shape",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M65.759,18.4 C65.9276667,18.4 66.0656667,18.3501667 66.173,18.2505 C66.2803333,18.1508333 66.334,18.0166667 66.334,17.848 L66.334,17.848 L66.334,16.284 C66.334,16.1153333 66.2803333,15.9811667 66.173,15.8815 C66.0656667,15.7818333 65.9276667,15.732 65.759,15.732 L65.759,15.732 L58.031,15.732 L58.031,11.569 L65.069,11.569 C65.2376667,11.569 65.3756667,11.5191667 65.483,11.4195 C65.5903333,11.3198333 65.644,11.1856667 65.644,11.017 L65.644,11.017 L65.644,9.568 C65.644,9.39933333 65.5903333,9.26133333 65.483,9.154 C65.3756667,9.04666667 65.2376667,8.993 65.069,8.993 L65.069,8.993 L58.031,8.993 L58.031,4.968 L65.575,4.968 C65.7436667,4.968 65.8816667,4.91816667 65.989,4.8185 C66.0963333,4.71883333 66.15,4.58466667 66.15,4.416 L66.15,4.416 L66.15,2.875 C66.15,2.70633333 66.0963333,2.56833333 65.989,2.461 C65.8816667,2.35366667 65.7436667,2.3 65.575,2.3 L65.575,2.3 L55.432,2.3 C55.2633333,2.3 55.1291667,2.35366667 55.0295,2.461 C54.9298333,2.56833333 54.88,2.70633333 54.88,2.875 L54.88,2.875 L54.88,17.848 C54.88,18.0013333 54.9336667,18.1316667 55.041,18.239 C55.1483333,18.3463333 55.2786667,18.4 55.432,18.4 L55.432,18.4 L65.759,18.4 Z",
                                    id: "Path",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M78.218,2.3 L78.5668184,2.30512109 C80.286877,2.35633203 81.6464375,2.791625 82.6455,3.611 C83.7111667,4.485 84.244,5.727 84.244,7.337 C84.244,8.45633333 83.9756667,9.3955 83.439,10.1545 C82.9023333,10.9135 82.151,11.4616667 81.185,11.799 L81.185,11.799 L84.52,17.664 L84.5583333,17.7534444 C84.5787778,17.8113704 84.589,17.8658889 84.589,17.917 C84.589,18.055 84.5391667,18.17 84.4395,18.262 C84.3398333,18.354 84.2286667,18.4 84.106,18.4 L84.106,18.4 L81.99,18.4 L81.84924,18.3931 C81.6701467,18.3747 81.5254,18.3195 81.415,18.2275 C81.277,18.1125 81.1543333,17.963 81.047,17.779 L81.047,17.779 L78.103,12.328 L74.952,12.328 L74.952,17.848 L74.94556,17.93724 C74.9283867,18.0525467 74.8768667,18.1531333 74.791,18.239 C74.6836667,18.3463333 74.5456667,18.4 74.377,18.4 L74.377,18.4 L72.261,18.4 L72.17176,18.39356 C72.0564533,18.3763867 71.9558667,18.3248667 71.87,18.239 C71.7626667,18.1316667 71.709,18.0013333 71.709,17.848 L71.709,17.848 L71.709,2.875 L71.71498,2.77748 C71.7309267,2.65236 71.7787667,2.54686667 71.8585,2.461 C71.9581667,2.35366667 72.0923333,2.3 72.261,2.3 L72.261,2.3 L78.218,2.3 Z M78.149,4.876 L74.952,4.876 L74.952,9.706 L78.149,9.706 C79.069,9.706 79.759,9.50283333 80.219,9.0965 C80.679,8.69016667 80.909,8.096 80.909,7.314 C80.909,6.532 80.679,5.93016667 80.219,5.5085 C79.759,5.08683333 79.069,4.876 78.149,4.876 L78.149,4.876 Z",
                                    id: "Combined-Shape",
                                    stroke: "#74FFF1",
                                    fill: "#74FFF1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M93.713,18.4 C94.127,18.4 94.3953333,18.2083333 94.518,17.825 L94.518,17.825 L97.094,10.189 L99.67,17.825 C99.716,17.9783333 99.808,18.1125 99.946,18.2275 C100.084,18.3425 100.260333,18.4 100.475,18.4 L100.475,18.4 L102.039,18.4 C102.269,18.4 102.456833,18.3386667 102.6025,18.216 C102.748167,18.0933333 102.836333,17.9246667 102.867,17.71 L102.867,17.71 L105.581,2.967 C105.596333,2.921 105.604,2.85966667 105.604,2.783 C105.604,2.645 105.558,2.53 105.466,2.438 C105.374,2.346 105.266667,2.3 105.144,2.3 L105.144,2.3 L103.074,2.3 C102.690667,2.3 102.476,2.45333333 102.43,2.76 L102.43,2.76 L100.544,13.11 L98.474,6.44 C98.428,6.28666667 98.3436667,6.1525 98.221,6.0375 C98.0983333,5.9225 97.9373333,5.865 97.738,5.865 L97.738,5.865 L96.473,5.865 C96.1203333,5.865 95.8673333,6.05666667 95.714,6.44 L95.714,6.44 L93.667,13.11 L91.758,2.76 C91.7273333,2.59133333 91.666,2.4725 91.574,2.4035 C91.482,2.3345 91.3363333,2.3 91.137,2.3 L91.137,2.3 L89.067,2.3 C88.929,2.3 88.814,2.346 88.722,2.438 C88.63,2.53 88.584,2.645 88.584,2.783 L88.584,2.783 L88.607,2.967 L91.321,17.71 C91.4283333,18.17 91.7043333,18.4 92.149,18.4 L92.149,18.4 L93.713,18.4 Z",
                                    id: "Path",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M117.58,2.3 L117.708346,2.30709877 C118.038486,2.34495885 118.271704,2.53425926 118.408,2.875 L118.408,2.875 L123.928,17.71 L123.974,17.917 L123.96802,17.99704 C123.952073,18.10008 123.904233,18.1884 123.8245,18.262 C123.724833,18.354 123.613667,18.4 123.491,18.4 L123.491,18.4 L121.444,18.4 L121.327922,18.3931719 C121.067974,18.3613073 120.884333,18.2179167 120.777,17.963 L120.777,17.963 L119.719,15.18 L112.911,15.18 L111.853,17.963 L111.802328,18.0654219 C111.673193,18.288474 111.46775,18.4 111.186,18.4 L111.186,18.4 L109.139,18.4 L109.039813,18.391375 C108.944938,18.374125 108.863,18.331 108.794,18.262 C108.702,18.17 108.656,18.055 108.656,17.917 L108.656,17.917 L108.702,17.71 L114.222,2.875 L114.277654,2.75432099 C114.438181,2.45144033 114.69563,2.3 115.05,2.3 L115.05,2.3 L117.58,2.3 Z M116.315,5.428 L113.716,12.512 L118.914,12.512 L116.315,5.428 Z",
                                    id: "Combined-Shape",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M139.147,18.4 C139.315667,18.4 139.453667,18.3463333 139.561,18.239 C139.668333,18.1316667 139.722,18.0013333 139.722,17.848 L139.722,17.848 L139.722,16.192 C139.722,16.0386667 139.668333,15.9083333 139.561,15.801 C139.453667,15.6936667 139.315667,15.64 139.147,15.64 L139.147,15.64 L131.856,15.64 L131.856,2.852 C131.856,2.68333333 131.806167,2.54916667 131.7065,2.4495 C131.606833,2.34983333 131.472667,2.3 131.304,2.3 L131.304,2.3 L129.142,2.3 C128.988667,2.3 128.858333,2.34983333 128.751,2.4495 C128.643667,2.54916667 128.59,2.68333333 128.59,2.852 L128.59,2.852 L128.59,17.848 C128.59,18.0013333 128.643667,18.1316667 128.751,18.239 C128.858333,18.3463333 128.988667,18.4 129.142,18.4 L129.142,18.4 L139.147,18.4 Z",
                                    id: "Path",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                    d: "M155.01,18.4 C155.178667,18.4 155.316667,18.3463333 155.424,18.239 C155.531333,18.1316667 155.585,18.0013333 155.585,17.848 L155.585,17.848 L155.585,16.192 C155.585,16.0386667 155.531333,15.9083333 155.424,15.801 C155.316667,15.6936667 155.178667,15.64 155.01,15.64 L155.01,15.64 L147.719,15.64 L147.719,2.852 C147.719,2.68333333 147.669167,2.54916667 147.5695,2.4495 C147.469833,2.34983333 147.335667,2.3 147.167,2.3 L147.167,2.3 L145.005,2.3 C144.851667,2.3 144.721333,2.34983333 144.614,2.4495 C144.506667,2.54916667 144.453,2.68333333 144.453,2.852 L144.453,2.852 L144.453,17.848 C144.453,18.0013333 144.506667,18.1316667 144.614,18.239 C144.721333,18.3463333 144.851667,18.4 145.005,18.4 L145.005,18.4 L155.01,18.4 Z",
                                    id: "Path",
                                    stroke: "#FFFFFF",
                                    fill: "#FFFFFF"
                                })
                            ]
                        })
                    })
                })
            });
        case "logo-color":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                className: className,
                viewBox: "0 0 46 43",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                        width: "46",
                        height: "43"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10.9399 36.7987C11.1706 36.7987 11.354 36.7316 11.4903 36.5975C11.6267 36.4634 11.6948 36.2828 11.6948 36.0559V33.8893C13.9176 33.6623 15.6844 32.9917 16.995 31.8774C18.3057 30.7632 18.961 29.3084 18.961 27.5133C18.961 26.2958 18.6989 25.2951 18.1746 24.511C17.6503 23.7269 16.8377 23.0769 15.7368 22.561C14.6359 22.0452 13.1522 21.5809 11.2859 21.1682C9.94379 20.8381 8.91101 20.5285 8.18754 20.2397C7.46407 19.9508 6.93981 19.6206 6.61477 19.2492C6.28974 18.8778 6.12722 18.4135 6.12722 17.8564C6.12722 17.031 6.4575 16.4017 7.11806 15.9684C7.77862 15.535 8.68558 15.3184 9.83894 15.3184C10.8875 15.3184 11.763 15.5402 12.4655 15.9838C13.168 16.4275 13.5821 16.9794 13.7079 17.6397C13.8757 18.0112 14.1798 18.1969 14.6201 18.1969H17.6084C17.7971 18.1969 17.9544 18.135 18.0802 18.0112C18.2061 17.8874 18.269 17.7326 18.269 17.5469C18.227 16.7834 17.9492 15.9993 17.4354 15.1946C16.9216 14.3898 16.1772 13.6831 15.2021 13.0744C14.227 12.4657 13.0579 12.0685 11.6948 11.8828V9.68522C11.6948 9.45824 11.6267 9.27769 11.4903 9.14357C11.354 9.00944 11.1706 8.94238 10.9399 8.94238H8.98965C8.77995 8.94238 8.6017 9.00944 8.45491 9.14357C8.30812 9.27769 8.23472 9.45824 8.23472 9.68522V11.8209C6.17964 12.0685 4.55969 12.7494 3.37488 13.8637C2.19006 14.9779 1.59765 16.3398 1.59765 17.9493C1.59765 19.7238 2.17433 21.0857 3.32769 22.0348C4.48105 22.984 6.29498 23.7475 8.76946 24.3253C10.2583 24.7173 11.3855 25.0526 12.1509 25.3312C12.9163 25.6097 13.4878 25.9347 13.8652 26.3061C14.2427 26.6776 14.4314 27.1418 14.4314 27.699C14.4314 28.545 14.0592 29.2104 13.3148 29.6953C12.5703 30.1802 11.4746 30.4227 10.0277 30.4227C8.72752 30.4227 7.70522 30.1854 6.96078 29.7108C6.21634 29.2362 5.72878 28.6481 5.49811 27.9466C5.37229 27.7402 5.24122 27.5906 5.10492 27.4978C4.96861 27.4049 4.77464 27.3585 4.52299 27.3585H1.69202C1.50328 27.3585 1.34077 27.4256 1.20446 27.5597C1.06815 27.6938 1 27.8434 1 28.0085C1.04194 28.9577 1.34077 29.8501 1.89648 30.6858C2.45219 31.5215 3.27003 32.2282 4.34999 32.806C5.42996 33.3837 6.72487 33.7448 8.23472 33.8893V36.0559C8.23472 36.2828 8.30812 36.4634 8.45491 36.5975C8.6017 36.7316 8.77995 36.7987 8.98965 36.7987H10.9399Z",
                        fill: "#74FFF1",
                        stroke: "#74FFF1",
                        strokeWidth: "0.5"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M28.7343 29.666C29.3005 29.666 29.6674 29.4081 29.8352 28.8922L33.3582 18.6163L36.8812 28.8922C36.9441 29.0986 37.0699 29.2791 37.2586 29.4339C37.4474 29.5886 37.6885 29.666 37.9821 29.666H40.1211C40.4356 29.666 40.6925 29.5835 40.8917 29.4184C41.091 29.2533 41.2115 29.0264 41.2535 28.7375L44.9652 8.89759C44.9862 8.83569 44.9967 8.75315 44.9967 8.64998C44.9967 8.46427 44.9337 8.30951 44.8079 8.18571C44.6821 8.0619 44.5353 8 44.3676 8H41.5366C41.0123 8 40.7187 8.20634 40.6558 8.61903L38.0765 22.5472L35.2455 13.5713C35.1826 13.3649 35.0673 13.1844 34.8995 13.0296C34.7317 12.8749 34.5116 12.7975 34.2389 12.7975H32.5089C32.0266 12.7975 31.6806 13.0554 31.4709 13.5713L28.6713 22.5472L26.0606 8.61903C26.0186 8.39205 25.9347 8.23214 25.8089 8.13928C25.6831 8.04643 25.4839 8 25.2113 8H22.3803C22.1916 8 22.0343 8.0619 21.9085 8.18571C21.7826 8.30951 21.7197 8.46427 21.7197 8.64998L21.7512 8.89759L25.4629 28.7375C25.6097 29.3565 25.9872 29.666 26.5953 29.666H28.7343Z",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: "0.5"
                    })
                ]
            });
        case "logo":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                className: className,
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M11.6704 5C11.5073 5 11.3555 5.05276 11.2344 5.16513C11.1125 5.27817 11.0514 5.42445 11.0514 5.5855V5.60232L11.0714 5.75125L13.0539 15.7426L13.0555 15.7488C13.1046 15.9442 13.1995 16.1174 13.358 16.24C13.5171 16.3629 13.712 16.4131 13.9185 16.4131H15.0594C15.2494 16.4131 15.4302 16.3721 15.5831 16.2707C15.737 16.1688 15.8391 16.0214 15.8987 15.8496L17.5257 11.3752L19.1519 15.8475C19.2041 16.0053 19.3053 16.1359 19.4399 16.24C19.5973 16.3617 19.7885 16.4131 19.992 16.4131H21.1328C21.3471 16.4131 21.5474 16.3593 21.7112 16.2314C21.8739 16.1042 21.9677 15.9309 21.9997 15.7315L23.9755 5.77354C23.9947 5.71046 24 5.64489 24 5.5855C24 5.42445 23.9388 5.27817 23.817 5.16513C23.7024 5.05877 23.5588 5 23.3978 5H21.8878C21.7184 5 21.5493 5.03077 21.4102 5.12292C21.2637 5.21999 21.1825 5.36387 21.1554 5.52524L19.975 11.5351L18.7868 7.98302L18.7863 7.98162C18.7373 7.83092 18.6479 7.70169 18.5258 7.59548C18.3776 7.46658 18.1921 7.41265 17.9954 7.41265H17.0727C16.8954 7.41265 16.7284 7.45826 16.5848 7.55915C16.4435 7.65853 16.3428 7.79888 16.273 7.96065L16.2686 7.97086L15.0903 11.5328L13.8952 5.52132C13.8658 5.37127 13.7979 5.21826 13.6545 5.11853C13.519 5.02423 13.344 5 13.1803 5H11.6704Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4.52814 5.4738C4.35584 5.4738 4.19642 5.52773 4.06582 5.64024C3.92315 5.76316 3.85881 5.92813 3.85881 6.10599V6.95366C2.83079 7.10357 1.98923 7.45269 1.35342 8.01647C0.66785 8.62437 0.318771 9.37785 0.318771 10.262C0.318771 11.2182 0.652159 11.9836 1.3416 12.5186C2.00264 13.0315 3.01511 13.4261 4.3481 13.7199C5.13825 13.9161 5.72908 14.0822 6.12532 14.2182C6.51567 14.3521 6.78117 14.5002 6.94431 14.6516C7.0909 14.7876 7.16397 14.9526 7.16397 15.1651C7.16397 15.4946 7.01884 15.7501 6.69237 15.9506C6.3573 16.1564 5.83223 16.2763 5.08179 16.2763C4.41547 16.2763 3.92563 16.1609 3.58647 15.9571C3.23024 15.7429 3.01761 15.4911 2.91845 15.2068L2.90841 15.178L2.89175 15.1522C2.8128 15.0302 2.71863 14.9224 2.60337 14.8483C2.46934 14.7622 2.30612 14.7353 2.14574 14.7353H0.63577C0.466468 14.7353 0.313742 14.7947 0.191383 14.9082C0.0761004 15.0152 0 15.1548 0 15.3208V15.3266L0.000274989 15.3325C0.0250464 15.8611 0.202228 16.3559 0.524719 16.8132C0.851098 17.276 1.32453 17.6573 1.93042 17.9629C2.48333 18.2418 3.12778 18.4225 3.85881 18.5103V19.3678C3.85881 19.5457 3.92315 19.7106 4.06582 19.8336C4.19642 19.9461 4.35584 20 4.52814 20H5.56834C5.74388 20 5.91338 19.9504 6.04628 19.8271C6.18054 19.7025 6.23767 19.5395 6.23767 19.3678V18.5091C7.35069 18.3703 8.26679 18.0278 8.96789 17.4658C9.73008 16.8548 10.1133 16.0493 10.1133 15.0717C10.1133 14.4217 9.96461 13.8634 9.64687 13.4153C9.33263 12.9722 8.85545 12.6189 8.23745 12.3459C7.62637 12.0759 6.81535 11.8379 5.81195 11.6286C5.1018 11.4638 4.56552 11.3115 4.19682 11.1727C3.82908 11.0343 3.59323 10.8866 3.45964 10.7427C3.33552 10.609 3.26806 10.4395 3.26806 10.2153C3.26806 9.88594 3.39996 9.65288 3.67327 9.48384C3.96705 9.30214 4.39419 9.19754 4.98113 9.19754C5.50435 9.19754 5.91981 9.30181 6.24252 9.49397C6.57133 9.68975 6.73384 9.91251 6.78307 10.1561L6.78929 10.1869L6.80291 10.2153C6.86734 10.3498 6.96436 10.4623 7.09735 10.5388C7.22863 10.6144 7.3776 10.6451 7.5313 10.6451H9.12516C9.28819 10.6451 9.44004 10.5924 9.56116 10.48C9.683 10.367 9.74415 10.2207 9.74415 10.0596V10.0523L9.74373 10.045C9.71811 9.60534 9.54899 9.16771 9.25578 8.73469C8.95575 8.29159 8.52676 7.91112 7.98004 7.58932C7.48027 7.29517 6.8978 7.09649 6.23767 6.98853V6.10599C6.23767 5.93429 6.18054 5.77128 6.04628 5.64671C5.91338 5.52341 5.74388 5.4738 5.56834 5.4738H4.52814Z",
                        fill: color
                    })
                ]
            });
        case "node-image":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeWidth: "1",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            d: "M14.5,15.5h-13 c-0.552,0-1-0.448-1-1v-13c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1v13C15.5,15.052,15.052,15.5,14.5,15.5z"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            points: "2.5,12.5 9.5,7.5 13.5,11.5 ",
                            "data-color": "color-2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            cx: "4.5",
                            cy: "5.5",
                            r: "1.5",
                            "data-color": "color-2",
                            "data-stroke": "none",
                            stroke: "none"
                        })
                    ]
                })
            });
        case "node-div":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                        x: "2",
                        y: "2",
                        width: "20",
                        height: "20",
                        fill: "none",
                        stroke: color,
                        strokeMiterlimit: "10"
                    })
                })
            });
        case "node-text":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "12",
                            y1: "2",
                            x2: "12",
                            y2: "22",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "butt"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "8",
                            y1: "22",
                            x2: "16",
                            y2: "22",
                            fill: "none",
                            stroke: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            points: "21 5 19 2 5 2 3 5",
                            fill: "none",
                            stroke: color
                        })
                    ]
                })
            });
        case "node-video":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeWidth: "1",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "0.5",
                            y: "2.5",
                            width: "15",
                            height: "12",
                            rx: "1",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            points: "6.5 5.5 11.5 8.5 6.5 11.5 6.5 5.5",
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            "data-color": "color-2"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            x1: "3.5",
                            y1: "0.5",
                            x2: "12.5",
                            y2: "0.5",
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            });
        case "plus":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "12",
                            y1: "2",
                            x2: "12",
                            y2: "22"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "22",
                            y1: "12",
                            x2: "2",
                            y2: "12"
                        })
                    ]
                })
            });
        case "node-z-stack":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polygon", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            points: "2,7 12,1 22,7 12,13 "
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            points: " 22,12 12,18 2,12 "
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("polyline", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            points: " 22,17 12,23 2,17 "
                        })
                    ]
                })
            });
        case "node-stack":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "4",
                            y: "1",
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            width: "16",
                            height: "7"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                            x: "4",
                            y: "16",
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            width: "16",
                            height: "7"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            x1: "1",
                            y1: "12",
                            x2: "23",
                            y2: "12"
                        })
                    ]
                })
            });
        case "node-navigation":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                fill: "none",
                viewBox: "0 0 16 16",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M2.5 3.20001V15.3H11.3",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeOpacity: "0.87",
                        strokeWidth: "1.16667"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M13.5 1H4.70001V13.1H13.5V1Z",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeOpacity: "0.87",
                        strokeWidth: "1.16667"
                    })
                ]
            });
        case "properties-linked":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 11 19",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M1.48492 1.42016C0.565686 2.33939 -1.2666e-07 3.61219 0.0707106 4.95569L0 6.58204C0 7.14772 0.424264 7.57198 0.98995 7.57198C1.55563 7.57198 1.9799 7.14772 1.9799 6.58204L1.9799 4.88498C1.9799 3.32934 3.39411 1.91513 4.94975 1.91513C5.79828 1.91513 6.57609 2.26868 7.14178 2.83437C7.70746 3.40005 8.06102 4.17787 7.99031 4.95569L8.06102 6.58204C8.06102 7.14772 8.48528 7.57198 9.05097 7.57198C9.33381 7.57198 9.61665 7.43056 9.75807 7.28914C9.8995 7.14772 10.0409 6.86488 10.0409 6.58204L10.0409 4.88498C10.0409 3.61219 9.47523 2.33939 8.55599 1.42016C7.63675 0.500917 6.36396 -0.0647687 5.02046 0.00594198C3.67696 -0.0647687 2.40416 0.500917 1.48492 1.42016Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8.06102 11.8147V13.5118C8.06102 15.0674 6.6468 16.4816 5.09117 16.4816C4.24264 16.4816 3.46482 16.128 2.89914 15.5624C2.33345 14.9967 1.9799 14.2189 2.05061 13.441L1.9799 11.8147C1.9799 11.249 1.55563 10.8247 0.98995 10.8247C0.424264 10.8247 0 11.249 0 11.8147L0.0707106 13.441C-1.2666e-07 14.7845 0.565686 16.0573 1.48492 16.9766C2.40416 17.8958 3.67696 18.4615 5.02046 18.3908C6.36396 18.4615 7.63675 17.8958 8.55599 16.9766C9.47523 16.0573 10.0409 14.7845 9.97021 13.441V11.744C9.97021 11.1783 9.54594 10.754 8.98026 10.754C8.41457 10.754 8.06102 11.249 8.06102 11.8147Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M4.03064 6.22815L4.03064 12.1678C4.03064 12.7335 4.4549 13.1578 5.02059 13.1578C5.30343 13.1578 5.58627 13.0164 5.72769 12.875C5.86911 12.7335 6.01054 12.4507 6.01054 12.1678L6.01054 6.22815C6.01054 5.66246 5.58627 5.2382 5.02059 5.2382C4.4549 5.2382 4.03064 5.66247 4.03064 6.22815Z",
                        fill: color
                    })
                ]
            });
        case "properties-unlinked":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 11 19",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M1.48492 1.42016C0.565686 2.33939 -1.2666e-07 3.61219 0.0707106 4.95569L0 6.58204C0 7.14772 0.424264 7.57198 0.98995 7.57198C1.55563 7.57198 1.9799 7.14772 1.9799 6.58204L1.9799 4.88498C1.9799 3.32934 3.39411 1.91513 4.94975 1.91513C5.79828 1.91513 6.57609 2.26868 7.14178 2.83437C7.70746 3.40005 8.06102 4.17787 7.99031 4.95569L8.06102 6.58204C8.06102 7.14772 8.48528 7.57198 9.05097 7.57198C9.33381 7.57198 9.61665 7.43056 9.75807 7.28914C9.8995 7.14772 10.0409 6.86488 10.0409 6.58204L10.0409 4.88498C10.0409 3.61219 9.47523 2.33939 8.55599 1.42016C7.63675 0.500917 6.36396 -0.0647687 5.02046 0.00594198C3.67696 -0.0647687 2.40416 0.500917 1.48492 1.42016Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M8.06102 11.8147V13.5118C8.06102 15.0674 6.6468 16.4816 5.09117 16.4816C4.24264 16.4816 3.46482 16.128 2.89914 15.5624C2.33345 14.9967 1.9799 14.2189 2.05061 13.441L1.9799 11.8147C1.9799 11.249 1.55563 10.8247 0.98995 10.8247C0.424264 10.8247 0 11.249 0 11.8147L0.0707106 13.441C-1.2666e-07 14.7845 0.565686 16.0573 1.48492 16.9766C2.40416 17.8958 3.67696 18.4615 5.02046 18.3908C6.36396 18.4615 7.63675 17.8958 8.55599 16.9766C9.47523 16.0573 10.0409 14.7845 9.97021 13.441V11.744C9.97021 11.1783 9.54594 10.754 8.98026 10.754C8.41457 10.754 8.06102 11.249 8.06102 11.8147Z",
                        fill: color
                    })
                ]
            });
        case "italic":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 12 12",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4 0V2H6.58L2.92 10H0V12H8V10H5.42L9.08 2H12V0H4Z",
                    fill: color
                })
            });
        case "italic-not":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 8 12",
                fill: color,
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M0 0H8V2H5V10H8V12H0V10H3V2H0V0Z",
                    fill: color
                })
            });
        case "youtube":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                width: width,
                height: height,
                viewBox: "0 0 146 33",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M45.5893 5.69901C45.324 4.73036 44.804 3.84717 44.0816 3.13788C43.3591 2.4286 42.4596 1.91813 41.4729 1.65759C37.8415 0.702271 23.2812 0.702271 23.2812 0.702271C23.2812 0.702271 8.7206 0.702271 5.08944 1.65759C4.10283 1.91815 3.20327 2.42864 2.48083 3.13791C1.75839 3.84719 1.23844 4.73037 0.973044 5.69901C0 9.26432 0 16.7023 0 16.7023C0 16.7023 0 24.1405 0.973044 27.7053C1.23842 28.6739 1.75836 29.5571 2.4808 30.2664C3.20324 30.9757 4.10282 31.4861 5.08944 31.7467C8.7206 32.7023 23.2812 32.7023 23.2812 32.7023C23.2812 32.7023 37.8415 32.7023 41.4729 31.7467C42.4596 31.4862 43.3592 30.9757 44.0816 30.2664C44.8041 29.5571 45.324 28.6739 45.5893 27.7053C46.5624 24.1402 46.5624 16.702 46.5624 16.702C46.5624 16.702 46.5624 9.26432 45.5893 5.69901Z",
                        fill: "#FF0000"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M18.625 23.5595L30.7218 16.7023L18.625 9.84521V23.5595ZM72.7464 26.6752C73.0013 26.0222 73.1293 24.9542 73.1293 23.472V17.2281C73.1293 15.7896 73.0013 14.7384 72.7464 14.0735C72.4911 13.4088 72.0415 13.0764 71.3982 13.0764C70.7764 13.0764 70.3375 13.4088 70.0825 14.0735C69.8272 14.7384 69.6996 15.7896 69.6996 17.2281V23.472C69.6996 24.9537 69.8215 26.0219 70.0661 26.6752C70.3099 27.3294 70.7537 27.6559 71.3979 27.6559C72.0415 27.6559 72.4911 27.3294 72.7464 26.6752ZM67.5856 29.8141C66.6638 29.2045 66.0086 28.2562 65.6209 26.9696C65.2322 25.6843 65.0382 23.9732 65.0382 21.8374V18.9277C65.0382 16.7704 65.2598 15.0375 65.7039 13.73C66.1478 12.4225 66.8411 11.4691 67.7851 10.8697C68.7286 10.2705 69.9661 9.97051 71.4979 9.97051C73.0074 9.97051 74.217 10.2759 75.1274 10.8858C76.0372 11.4959 76.7032 12.4498 77.1252 13.7464C77.5466 15.0432 77.7576 16.7704 77.7576 18.9279V21.8377C77.7576 23.9732 77.5524 25.69 77.1419 26.9862C76.7308 28.283 76.0648 29.2313 75.1438 29.8302C74.2225 30.4296 72.974 30.7293 71.3982 30.7293C69.7769 30.7293 68.5064 30.424 67.5856 29.8141ZM138.89 13.4506C138.658 13.7342 138.502 14.1973 138.424 14.84C138.346 15.4829 138.308 16.4582 138.308 17.7658V19.2042H141.671V17.7655C141.671 16.48 141.626 15.5046 141.538 14.8397C141.449 14.1751 141.288 13.7068 141.055 13.4342C140.822 13.1616 140.461 13.0253 139.973 13.0253C139.484 13.0253 139.123 13.1672 138.89 13.4503V13.4506ZM138.308 21.8851V22.8985C138.308 24.1846 138.346 25.149 138.424 25.7916C138.502 26.4348 138.662 26.9035 138.907 27.1976C139.151 27.4914 139.528 27.639 140.039 27.639C140.727 27.639 141.199 27.3774 141.454 26.8541C141.709 26.3312 141.848 25.4594 141.87 24.2385L145.833 24.4677C145.855 24.6427 145.866 24.8823 145.866 25.1868C145.866 27.0396 145.35 28.4239 144.318 29.3388C143.286 30.2538 141.826 30.7118 139.939 30.7118C137.675 30.7118 136.088 30.0147 135.178 28.6194C134.267 27.2253 133.812 25.0674 133.812 22.1467V18.6485C133.812 15.6409 134.284 13.4455 135.228 12.0609C136.171 10.6772 137.786 9.98519 140.073 9.98519C141.649 9.98519 142.858 10.2685 143.702 10.8352C144.545 11.4025 145.139 12.285 145.483 13.4833C145.828 14.6819 146 16.3386 146 18.4524V21.8851H138.308ZM56.3964 21.5097L51.1684 2.97339H55.73L57.5611 11.3751C58.0277 13.4464 58.3718 15.2117 58.5934 16.6713H58.7268C58.882 15.6254 59.2264 13.8711 59.759 11.4079L61.6571 2.97339H66.2188L60.9247 21.5097V30.4025H56.3961V21.5097M92.5944 10.3628V30.4025H88.9981L88.5985 27.9506H88.4988C87.5217 29.8031 86.0565 30.7291 84.1032 30.7291C82.7493 30.7291 81.7504 30.2936 81.1065 29.4215C80.4626 28.5503 80.1409 27.1877 80.1409 25.3349V10.3628H84.7359V25.0739C84.7359 25.968 84.836 26.6052 85.0358 26.9862C85.2355 27.3681 85.5684 27.5583 86.0347 27.5583C86.4342 27.5583 86.8171 27.4389 87.1833 27.1985C87.5496 26.9589 87.8215 26.6543 87.9992 26.2838V10.3625L92.5944 10.3628ZM116.165 10.3628V30.4025H112.568L112.168 27.9506H112.069C111.091 29.8031 109.626 30.7291 107.673 30.7291C106.319 30.7291 105.32 30.2936 104.676 29.4215C104.032 28.5503 103.711 27.1877 103.711 25.3349V10.3628H108.306V25.0739C108.306 25.968 108.406 26.6052 108.605 26.9862C108.805 27.3681 109.138 27.5583 109.604 27.5583C110.004 27.5583 110.387 27.4389 110.753 27.1985C111.12 26.9589 111.391 26.6543 111.569 26.2838V10.3625H116.164",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M105.081 6.603H100.519V30.4025H96.0236V6.60272H91.4619V2.97419H105.081V6.603ZM127.16 21.7402C127.16 23.2005 127.099 24.3449 126.977 25.1726C126.855 26.0015 126.649 26.5897 126.361 26.9379C126.072 27.2868 125.683 27.4612 125.196 27.4612C124.829 27.4642 124.467 27.3741 124.146 27.1995C123.824 27.0251 123.564 26.7638 123.364 26.415V15.038C123.519 14.4934 123.786 14.0466 124.163 13.6978C124.541 13.3495 124.951 13.1748 125.395 13.1748C125.861 13.1748 126.222 13.3546 126.477 13.7139C126.732 14.0737 126.91 14.6785 127.01 15.5285C127.11 16.3783 127.16 17.5879 127.16 19.1571V21.7402ZM131.372 13.566C131.094 12.3022 130.645 11.3869 130.023 10.82C129.402 10.2535 128.547 9.97019 127.46 9.97019C126.616 9.97019 125.828 10.2044 125.096 10.6729C124.373 11.1305 123.787 11.7679 123.397 12.5201H123.364L123.364 1.96045H118.936V30.4019H122.731L123.198 28.5062H123.297C123.652 29.1816 124.185 29.7156 124.896 30.1078C125.606 30.5001 126.394 30.6963 127.26 30.6963C128.813 30.6963 129.957 29.9933 130.69 28.5878C131.422 27.1818 131.788 24.9866 131.788 22.0005V18.8294C131.788 16.5849 131.649 14.8303 131.372 13.566Z",
                        fill: "white"
                    })
                ]
            });
        case "shadow-inside":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                        opacity: "0.1",
                        cx: "8",
                        cy: "8",
                        r: "8",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                        cx: "8",
                        cy: "8",
                        r: "4",
                        fill: color
                    })
                ]
            });
        case "shadow-outside":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                        opacity: "0.1",
                        cx: "8",
                        cy: "8",
                        r: "6",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
                        fill: color
                    })
                ]
            });
        case "paywalled-user":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 12 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 2C0 0.895431 0.895431 0 2 0H10C11.1046 0 12 0.895431 12 2V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V2ZM2.95 13C2.7016 13 2.5 12.8133 2.5 12.5833C2.5 10.2858 3.5187 8.75 6 8.75C8.4813 8.75 9.5 10.2858 9.5 12.5833C9.5 12.8133 9.2984 13 9.05 13H2.95ZM6 7.5C7.38071 7.5 8.5 6.43668 8.5 5.125C8.5 3.81332 7.38071 2.75 6 2.75C4.61929 2.75 3.5 3.81332 3.5 5.125C3.5 6.43668 4.61929 7.5 6 7.5Z",
                    fill: color
                })
            });
        case "paywall-rate":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                width: width,
                className: className,
                height: height,
                viewBox: "0 0 12 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0 2C0 0.895431 0.895431 0 2 0H10C11.1046 0 12 0.895431 12 2V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V2ZM1.5 3C1.5 2.44772 1.94772 2 2.5 2H9.5C10.0523 2 10.5 2.44772 10.5 3V13C10.5 13.5523 10.0523 14 9.5 14H2.5C1.94772 14 1.5 13.5523 1.5 13V3ZM3 10C2.72386 10 2.5 10.2239 2.5 10.5V12.5C2.5 12.7761 2.72386 13 3 13H9C9.27614 13 9.5 12.7761 9.5 12.5V10.5C9.5 10.2239 9.27614 10 9 10H3Z",
                    fill: color
                })
            });
        case "paywall-conversion":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    fill: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            cx: "8",
                            cy: "8",
                            r: "3"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M3.7,2.387A1,1,0,0,0,2.286,2.4a8,8,0,0,0,0,11.2,1,1,0,1,0,1.428-1.4,6,6,0,0,1,0-8.4A1,1,0,0,0,3.7,2.387Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M13.714,2.4a1,1,0,1,0-1.428,1.4,6,6,0,0,1,0,8.4,1,1,0,0,0,1.428,1.4,8,8,0,0,0,0-11.2Z",
                            fill: color
                        })
                    ]
                })
            });
        case "proceeds":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 11 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M5.08587 16.3999C4.96735 16.3999 4.86661 16.3584 4.78365 16.2755C4.70068 16.2043 4.6592 16.1036 4.6592 15.9732V14.7288C3.80587 14.6458 3.07105 14.4384 2.45476 14.1066C1.85031 13.7747 1.38809 13.3718 1.06809 12.8977C0.759942 12.4118 0.594016 11.8962 0.570312 11.351C0.570312 11.2562 0.605868 11.1732 0.676979 11.1021C0.759942 11.0192 0.854757 10.9777 0.961424 10.9777H2.56142C2.70365 10.9777 2.81031 11.0073 2.88142 11.0666C2.96439 11.114 3.04142 11.1969 3.11253 11.3155C3.24291 11.7184 3.5155 12.0562 3.93031 12.3288C4.35698 12.6014 4.93772 12.7377 5.67254 12.7377C6.49031 12.7377 7.10661 12.6014 7.52142 12.3288C7.94809 12.0443 8.16142 11.6592 8.16142 11.1732C8.16142 10.8532 8.05476 10.5866 7.84142 10.3732C7.62809 10.1599 7.30216 9.9762 6.86365 9.82212C6.43698 9.6562 5.80291 9.46064 4.96142 9.23546C3.56291 8.90361 2.53772 8.46509 1.88587 7.9199C1.23402 7.37472 0.90809 6.59249 0.90809 5.57324C0.90809 4.64879 1.23994 3.86657 1.90365 3.22657C2.5792 2.58657 3.49772 2.19546 4.6592 2.05324V0.826569C4.6592 0.696198 4.70068 0.595457 4.78365 0.524346C4.86661 0.441384 4.96735 0.399902 5.08587 0.399902H6.18809C6.31846 0.399902 6.4192 0.441384 6.49031 0.524346C6.57328 0.595457 6.61476 0.696198 6.61476 0.826569V2.08879C7.38513 2.19546 8.0429 2.42657 8.58809 2.78212C9.14513 3.12583 9.56587 3.52879 9.85031 3.99101C10.1466 4.45324 10.3066 4.90361 10.3303 5.34212C10.3303 5.44879 10.2948 5.53768 10.2236 5.60879C10.1525 5.6799 10.0636 5.71546 9.95698 5.71546H8.26809C8.0192 5.71546 7.84735 5.60879 7.75254 5.39546C7.68142 5.0162 7.44439 4.70212 7.04142 4.45324C6.65031 4.19249 6.15846 4.06212 5.56587 4.06212C4.91402 4.06212 4.39846 4.18657 4.0192 4.43546C3.65179 4.68435 3.46809 5.04583 3.46809 5.5199C3.46809 5.8399 3.55698 6.10657 3.73476 6.3199C3.92439 6.53324 4.22068 6.72287 4.62365 6.88879C5.03846 7.05472 5.62513 7.23249 6.38365 7.42212C7.43846 7.65916 8.27402 7.92583 8.89031 8.22212C9.51846 8.51842 9.98068 8.89175 10.277 9.34212C10.5733 9.7925 10.7214 10.3673 10.7214 11.0666C10.7214 12.0977 10.3481 12.9332 9.60142 13.5732C8.86661 14.2132 7.87105 14.5984 6.61476 14.7288V15.9732C6.61476 16.1036 6.57328 16.2043 6.49031 16.2755C6.4192 16.3584 6.31846 16.3999 6.18809 16.3999H5.08587Z",
                    fill: color
                })
            });
        case "plus-thick":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "3",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "12",
                            y1: "2",
                            x2: "12",
                            y2: "22"
                        }),
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("line", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            x1: "22",
                            y1: "12",
                            x2: "2",
                            y2: "12"
                        })
                    ]
                })
            });
        case "globe":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                fill: "none",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.17156 8.07011L6.85387 10.0833C7.50915 10.5752 8.44975 10.3548 8.81836 9.62306C8.99021 9.28194 9.30184 9.03235 9.67226 8.93916L11.8457 8.39241C12.5416 8.21734 13.0847 7.67348 13.2587 6.97732L14.126 3.50882M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.4252 15.9984L10.6023 14.7641C10.2853 14.2886 10.3486 13.6553 10.7535 13.2519C10.9966 13.0096 11.3322 12.8834 11.6748 12.9052L12.5015 12.958C12.8453 12.9799 13.1771 13.0927 13.463 13.2848L14.8342 14.2063C15.4406 14.6138 15.6501 15.4083 15.3233 16.0618C15.0772 16.554 14.5742 16.8649 14.0239 16.8649H13.0443C12.3937 16.8649 11.7861 16.5397 11.4252 15.9984Z",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            });
        case "node-drawer":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M13 1H3V14.9335H13V1Z",
                        stroke: color,
                        "stroke-opacity": "0.87",
                        "stroke-width": "1.16667",
                        "stroke-miterlimit": "10",
                        "stroke-linecap": "square"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M6.21545 4.21542L9.78459 4.21542",
                        stroke: color,
                        "stroke-opacity": "0.87",
                        "stroke-miterlimit": "10",
                        "stroke-linecap": "square"
                    })
                ]
            });
        case "more-vertical":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                height: height,
                width: width,
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 5.5C12.8284 5.5 13.5 4.82842 13.5 4C13.5 3.17158 12.8284 2.5 12 2.5C11.1716 2.5 10.5 3.17158 10.5 4C10.5 4.82842 11.1716 5.5 12 5.5Z",
                        fill: color,
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z",
                        fill: color,
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M12 21.5C12.8284 21.5 13.5 20.8284 13.5 20C13.5 19.1716 12.8284 18.5 12 18.5C11.1716 18.5 10.5 19.1716 10.5 20C10.5 20.8284 11.1716 21.5 12 21.5Z",
                        fill: color,
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            });
        case "link":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                height: height,
                width: width,
                className: className,
                fill: "none",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10 5.5L10.7514 4.75837C13.0959 2.41387 16.8971 2.41388 19.2416 4.75837C21.5861 7.10287 21.5861 10.9041 19.2416 13.2486L18.5 14M5.5 10L4.75837 10.7514C2.41387 13.0959 2.41388 16.8971 4.75838 19.2416C7.10287 21.5861 10.9041 21.5861 13.2486 19.2416L14 18.5M10 14L14 10",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            });
        case "link-off":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                height: height,
                width: width,
                fill: "none",
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M10 5.5L10.7514 4.75837C13.0959 2.41387 16.8971 2.41388 19.2416 4.75837C21.5861 7.10287 21.5861 10.9041 19.2416 13.2486L18.5 14M5.5 10L4.75837 10.7514C2.41387 13.0959 2.41388 16.8971 4.75838 19.2416C7.10287 21.5861 10.9041 21.5861 13.2486 19.2416L14 18.5M10 14L9 15M14 10L15 9",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M3 3L21 21",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeWidth: "2"
                    })
                ]
            });
        case "gift":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                height: height,
                width: width,
                fill: "none",
                className: className,
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M19 11.7324V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V11.7324M19 11.7324V11.5M19 11.7324C19.5978 11.3866 20 10.7403 20 10C20 8.89543 19.1046 8 18 8H6C4.89543 8 4 8.89543 4 10C4 10.7403 4.4022 11.3866 5 11.7324M19 11.7324C18.7058 11.9026 18.3643 12 18 12H6C5.63571 12 5.29417 11.9026 5 11.7324M5 11.7324V11.5M12 8V6.33333M12 8H10.3333C8.49238 8 7 6.50762 7 4.66667C7 3.74619 7.74619 3 8.66667 3C10.5076 3 12 4.49238 12 6.33333M12 8H13.6667C15.5076 8 17 6.50762 17 4.66667C17 3.74619 16.2538 3 15.3333 3C13.4924 3 12 4.49238 12 6.33333M12 8V20",
                    stroke: color,
                    strokeWidth: "2"
                })
            });
        case "google-play":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 137 154",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M2.62965 2.92578C0.851868 4.70356 0.259277 7.66652 0.259277 11.2221V142.185C0.259277 145.741 1.44446 148.704 3.22224 150.481L3.81484 151.074L77.2963 77.5924V76.4073L2.62965 2.92578Z",
                        fill: "url(#paint0_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M101 102.481L76.7037 78.1852V76.4074L101 52.1111L101.593 52.7037L130.63 69.2963C138.926 74.037 138.926 81.7407 130.63 86.4815L101 102.481Z",
                        fill: "url(#paint1_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M101.593 101.889L76.7037 77L2.62964 151.074C5.5926 154.037 9.74075 154.037 15.0741 151.667L101.593 101.889Z",
                        fill: "url(#paint2_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M101.593 52.1112L15.0741 2.92603C9.74075 -0.0369332 5.5926 0.555659 2.62964 3.51862L76.7037 77.0001L101.593 52.1112Z",
                        fill: "url(#paint3_linear_795_114)"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        opacity: "0.2",
                        d: "M101 101.296L15.0741 149.889C10.3333 152.852 6.1852 152.259 3.22223 149.889L2.62964 150.482L3.22223 151.074C6.1852 153.445 10.3333 154.037 15.0741 151.074L101 101.296Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        opacity: "0.12",
                        d: "M2.62965 149.889C0.851868 148.111 0.259277 145.148 0.259277 141.593V142.185C0.259277 145.741 1.44446 148.704 3.22224 150.481V149.889H2.62965ZM130.63 84.7037L101 101.296L101.593 101.889L130.63 85.2963C134.778 82.9259 136.556 79.963 136.556 77C136.556 79.963 134.185 82.3333 130.63 84.7037Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        opacity: "0.25",
                        d: "M15.0741 3.51852L130.63 69.2963C134.185 71.6667 136.556 74.037 136.556 77C136.556 74.037 134.778 71.0741 130.63 68.7037L15.0741 2.92593C6.7778 -1.81481 0.259277 1.74074 0.259277 11.2222V11.8148C0.259277 2.92593 6.7778 -1.22222 15.0741 3.51852Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint0_linear_795_114",
                                x1: "70.1852",
                                y1: "10.0962",
                                x2: "-29.2696",
                                y2: "109.545",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#00A0FF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.007",
                                        stopColor: "#00A1FF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.26",
                                        stopColor: "#00BEFF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.512",
                                        stopColor: "#00D2FF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.76",
                                        stopColor: "#00DFFF"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#00E3FF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint1_linear_795_114",
                                x1: "141.498",
                                y1: "77.0059",
                                x2: "-1.89182",
                                y2: "77.0059",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#FFE000"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.409",
                                        stopColor: "#FFBD00"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.775",
                                        stopColor: "#FFA500"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#FF9C00"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint2_linear_795_114",
                                x1: "88.123",
                                y1: "90.6059",
                                x2: "-46.7392",
                                y2: "225.468",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#FF3A44"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#C31162"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                                id: "paint3_linear_795_114",
                                x1: "-15.7585",
                                y1: "-40.4755",
                                x2: "44.4667",
                                y2: "19.7497",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        stopColor: "#32A071"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.069",
                                        stopColor: "#2DA771"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.476",
                                        stopColor: "#15CF74"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "0.801",
                                        stopColor: "#06E775"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#00F076"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case "node-animation":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                xmlns: "http://www.w3.org/2000/svg",
                width: width,
                height: height,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    strokeLinecap: "square",
                    strokeLinejoin: "miter",
                    strokeWidth: "2",
                    fill: color,
                    stroke: color,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("circle", {
                            "data-color": "color-2",
                            fill: "none",
                            strokeMiterlimit: "10",
                            cx: "19",
                            cy: "9",
                            r: "4"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            d: "M7,20c0-4.708,2.625-8,5.514-9",
                            strokeLinecap: "butt"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeMiterlimit: "10",
                            d: "M1,5c5,2.917,6,9.583,6,15",
                            strokeLinecap: "butt"
                        })
                    ]
                })
            });
        case "corners-all":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                className: className,
                width: width,
                height: height,
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2ZM3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V3C16 1.34315 14.6569 0 13 0H3Z",
                    fill: color
                })
            });
        default:
            return null;
    }
};
export { SIconLegacy, SIconLegacy_SIconLegacyType as SIconLegacyType };
